import { Form, FormInstance, FormProps } from "antd";
import React, { useEffect } from "react";

import { FormBlocker } from "../FormBlocker";

export type SafeFormProps = Omit<FormProps, "form"> & {
  children: React.ReactNode;
  form: FormInstance;
};

export const SafeForm: React.FC<SafeFormProps> = ({
  children,
  initialValues,
  form,
  ...props
}) => {
  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  return (
    <Form {...props} form={form} initialValues={initialValues}>
      <FormBlocker initialData={initialValues} form={form} />
      {children}
    </Form>
  );
};
